import { Member } from '../../shared/interfaces/member.interface';
import { MemberType } from '../../shared/enums/member-type.enum';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { Country } from '../../shared/interfaces/country.interface';
import { State } from '../../shared/interfaces/state.interface';


export class BaseSettings {
    userInfo: Member;
    isoCountryCode: string;
    languageCode: string;
    memberType = MemberType;
    store: StoreConfig;
    states: State[];
    countries: Country[];
    registerMemberType: MemberType;
}
